import React from 'react';
import shortid from 'shortid';

import Icon from '../../../molecules/Icon';

import SearchCard from './SearchCard';

import { color } from '../../../atoms/colors';
import { Container, Header, List } from '../styles/SearchBlock.styled';

const SearchBlock = ({ list, icon, searchQuery }) => (
  <Container className="search-block">
    {list?.length > 0 && (
      <Header>
        <Icon
          id={icon}
          width="24px"
          height="24px"
          fillColor={color.steel[700]}
        />
        Results
      </Header>
    )}
    {list?.length > 0 && (
      <List>
        {list?.map(item => (
          <SearchCard
            key={shortid.generate()}
            type={item.type}
            slug={item.slug}
            title={item._highlightResult?.title?.value || item.title}
            description={
              item._highlightResult?.description?.value || item.description
            }
          />
        ))}
      </List>
    )}
    {list?.length === 0 && (
      <p className="no-results">No results found for “{searchQuery}”.</p>
    )}
  </Container>
);

export default SearchBlock;
